export class CustomError extends Error {
    isCustomError = true;

    constructor(name: string, message: string) {
        super(message);
        this.name = name;
    }
}

export function isCustomError(error: any): error is CustomError {
    return error.isCustomError;
}
